import { useState } from "react";

interface PredictionsListProps {
  predictions: google.maps.places.AutocompletePrediction[];
  onSelect: (prediction: google.maps.places.AutocompletePrediction) => void;
  show: boolean;
}

const PredictionsList = ({ predictions, onSelect, show }: PredictionsListProps) => {
  if (!show || predictions.length === 0) return null;

  return (
    <div className="absolute z-10 w-full mt-1 bg-white rounded-md shadow-lg border border-gray-200 max-h-60 overflow-auto">
      {predictions.map((prediction) => (
        <div
          key={prediction.place_id}
          className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
          onClick={() => onSelect(prediction)}
        >
          {prediction.description}
        </div>
      ))}
    </div>
  );
};

export default PredictionsList;